module.exports = __webpack_public_path__ + "static/img/son7.e9ec6c21.png";